<script lang="ts" setup>
import type { StylesElementVersion, StylesSizes } from '#imports';
interface Props {
  version?: StylesElementVersion;
  icon?: string | null;
  rounded?: boolean;
  label?: string | undefined;
  size?: StylesSizes;
}
const props = withDefaults(defineProps<Props>(), {
  version: 'default',
  rounded: false,
  size: 'medium'
});
</script>

<template>
  <span :class="['tag', `tag-${props.version}`, `tag-${props.size}`, props.rounded ? 'rounded' : undefined]">
    <i v-if="icon" :class="icon"/>
    <span v-if="label">{{ label }}</span>
    <slot v-else />
  </span>
</template>

<style lang="postcss" scoped>
.tag,
.tag-medium {
  background-color: var(--color-slate-100);
  color: var(--color-slate-600);
  border-radius: 0.5rem;
  padding: 0.25rem 0.6rem;
  font-size: 0.875rem;
  display: flex;
  max-width: fit-content;
  align-items: center;
  gap: 0.25rem;
  letter-spacing: 0.05px;
}

.tag-small {
  padding: 0.125rem 0.4rem;
  font-size: 0.75rem;
  border-radius: 0.35rem;
}

.tag-large {
  padding: 0.375rem 0.8rem;
  font-size: 1rem;
}

.rounded {
  border-radius: 1rem;
}

i {
  margin-right: 0.25rem;
}

.tag-primary {
  background-color: var(--color-rose-100);

  color: var(--color-rose-600);
}

.tag-success {
  background-color: var(--color-green-100);
  color: var(--color-green-600);
}

.tag-error,
.tag-danger {
  background-color: var(--color-rose-100);
  color: var(--color-rose-600);
}

.tag-warning {
  background-color: var(--color-orange-100);
  color: var(--color-orange-600);
}

.tag-default {
  background-color: var(--color-slate-100);
  color: var(--color-slate-600);
}

.tag-info {
  background-color: var(--color-indigo-100);
  color: var(--color-indigo-600);
}
.tag-warning {
  background-color: var(--color-orange-100);
  color: var(--color-orange-600);
}
</style>
